import React from 'react';
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from 'perfect-scrollbar';
import { Route, Switch } from 'react-router-dom';

import IndexNavbar from 'views/layouts/index/IndexNavbar';

// import routes from 'routes.js';
// import nroutes from '../noSidebarRoutes.js';

import routesByAuth from 'commons/routes/routesByAuth.js';
import nroutesByAuth from 'commons/routes/noSidebarRoutesByAuth.js';

var ps;

class IndexLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      routes: routesByAuth(),
      nroutes: nroutesByAuth()
    };
  }

  componentDidMount() {
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(this.refs.fullPages);
    }
  }

  async componentWillUnmount() {
    if (navigator.platform.indexOf('Win') > -1) {
      ps.destroy();
    }
    await this.setState({
      ...this.state,
      routes: [],
      nroutes: []
    });
  }

  getRoutes = routes => {
    const concatRouters = this.state.nroutes.concat(routes);
    return concatRouters.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === '') {
        return (
          <Route
            path={prop.layout + prop.path}
            render={props => <prop.component endPoint={this.props.endPoint} {...props} />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  render() {
    return (
      <>
        <div ref="fullPages">
          <IndexNavbar />
          <div>
            <Switch>{this.getRoutes(this.state.routes)}</Switch>
          </div>
        </div>
      </>
    );
  }
}

export default IndexLayout;
